<div class="passport-insurances__item-wrapper" *ngIf="passportProducts; else loading">
    <wuc-rack
        class="passport-insurances__item-rack"
        columnsDesktop="4"
        columnsTablet="3"
        columnsMobile="2"
        gridGap="medium"
    >
        <ng-container *ngFor="let product of passportProducts; let i = index">
            <div class="passport-insurances__item-block" *ngIf="i < itemsVisible">
                <a
                    class="passport-insurances__item-link"
                    [class.passport-insurances__item-link--selected]="product.purchased"
                    (click)="selectInsurance(product)"
                    [href]="'../' + product.productDescription + '/berekenen-' + product.productDescription"
                >
                    <div class="passport-insurances__item-checked-circle" *ngIf="product.purchased">
                        <wuc-icon-ui
                            icon="check-closed"
                            type="white"
                            class="passport-insurances__item-checked"
                        ></wuc-icon-ui>
                    </div>
                    <wuc-icon
                        [icon]="product.productIcon"
                        [type]="product.purchased ? 'white' : 'secondary'"
                        size="xl"
                    ></wuc-icon>
                    <wuc-text-highlight
                        *ngIf="!product.purchased"
                        type="secondary"
                        class="passport-insurances__item-choose"
                    >
                        Kies
                    </wuc-text-highlight>
                </a>
                <span>{{ product.productText }}</span>
            </div>
        </ng-container>
    </wuc-rack>
    <div class="passport-insurances__toggle">
        <wuc-link type="secondary" (click)="toggle()" e2e="productpage-toggle-list">
            <span class="passport-insurances__toggle-text">
                Bekijk {{ isListVisible ? 'minder' : 'meer' }} verzekeringen
            </span>
            <br />
            <wuc-icon-ui [icon]="isListVisible ? 'arrow-up-bold' : 'arrow-down-bold'"></wuc-icon-ui>
        </wuc-link>
    </div>
</div>

<ng-template #loading>
    <div class="passport-insurances__item-wrapper">
        <wuc-rack
            class="passport-insurances__item-rack"
            columnsDesktop="4"
            columnsTablet="3"
            columnsMobile="2"
            gridGap="medium"
        >
            <ng-container *ngFor="let number of [0, 1, 2, 3, 4]; let i = index">
                <ng-container *ngIf="i < itemsVisible">
                    <wuc-skeleton class="passport-insurances__item-skeleton" width="95px" height="95px"></wuc-skeleton>
                </ng-container>
            </ng-container>
        </wuc-rack>
        <div class="passport-insurances__toggle">
            <wuc-skeleton class="passport-insurances__link-skeleton" height="1.6rem" width="7.5rem"></wuc-skeleton>
        </div>
    </div>
</ng-template>
